import PropTypes from 'prop-types';
import React from 'react';

import Sanitize from '@/src/shared/components/Sanitize';

const Background = ({ background }) => {
  return <Sanitize>{background}</Sanitize>;
};

Background.propTypes = {};

export default Background;
